export { default as SlidesFilters } from './filters'
export { default as SlidesList } from './list'
export { default as SlideDetail } from './detail'
export { default as SlideCreate } from './create'
export { default as SlideUpdate } from './update'
export { default as SlideForm, type SlideFormRef } from './form'
